
<template>
  <div id="user-edit-tab-info">
    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <div class="w-full mt-4">
          Client
          <div class="vx-row">
            <div class="vx-col w-2/3">
              <v-select autocomplete :options="data_option_people_name" v-model="dataIdPeople" />
            </div>
            <div class="vx-col w-1/3">
            <vs-button class="ml-auto" color="#333b34" @click="record_data_go_to_add_person()">Add Person</vs-button>
            </div>
          </div>
        </div>
        <p class="w-full mt-4"> Date
        <datepicker :inline="false" v-model="dataDate"></datepicker>
        </p>
      </div>
      <div class="vx-col md:w-1/2 w-full">
      </div>
    </div>
    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
         <vs-button class="ml-8" color="success" @click="save_changes(false)" :disabled="!validateForm">Next Step</vs-button>
        </div>
        <br/>
      </div>
    </div>
  </div>
</template>

<script>
import moduleOperationList from '@/store/operation/moduleOperationList.js'
import Datepicker from 'vuejs-datepicker'
import vSelect from 'vue-select'
import axios from '@/axios.js'
import moment from 'moment'

export default {
  components: {
    vSelect,
    Datepicker
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isMounted: false,
      // Data Sidebar
      buttonSubmitOpen: false,
      state:{},
      dataDate: '',
      dataOperationCategory:'2',
      dataIdPeople: '',
      data_option_people_name: [],
      maxdateoperation : ''
    }
    
  },
  computed: {
    validateForm () {
      return !this.errors.any() && (this.dataDate && this.dataOperationCategory)
    },
    currentPage () {
      if (this.isMounted) {
        if (this.data_local.id) return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      if (this.data_local.id) return this.$refs.table ? this.$refs.table.queriedResults.length : this.users.length
    }
  },
  methods: {
    getMaxInventoryDate()
    {
        var dateStop = moment(this.dataDate).add(12, 'hours').format('YYYY-MM-DD')
        axios.get('/getmaxinventorydate')
          .then((response) => {
            this.maxdateoperation = response.data
          })
    },
    record_data_go_to_add_person()
    {
        localStorage.setItem('creating-operation-and-need-to-add-user', true)
        localStorage.setItem('creating-operation-and-need-to-add-user-category', this.dataOperationCategory)
        localStorage.setItem('creating-operation-and-need-to-add-user-date', this.dataDate)
        localStorage.setItem('creating-operation-and-need-to-add-user-page-source', 'sale-add')
        this.$router.push('/person-add').catch(() => {})
    },
    async getPeople()
    {
      axios.get('/people_name/data')
        .then((response) => {
          this.data_option_people_name = [...response.data]
          this.setDataFromNewPerson()
        })
    },

    async setDataFromNewPerson() {
      if (localStorage.getItem('creating-operation-and-need-to-add-user')) {
        this.dataOperationCategory = localStorage.getItem('creating-operation-and-need-to-add-user-category');
        this.dataDate = localStorage.getItem('creating-operation-and-need-to-add-user-date');
        setTimeout(() => {
          const storedValue = Number(localStorage.getItem('creating-operation-and-need-to-add-user-person'));
          console.log("Valeur stockée :", storedValue);
          console.log("Liste des personnes :", this.data_option_people_name);

          if (!storedValue) {
            console.warn("⚠️ Aucune valeur trouvée dans localStorage !");
          } else {
            console.log("🔍 Recherche de l'élément correspondant...");
            this.dataIdPeople = this.data_option_people_name.find((p) => p.value.valueOf() === storedValue);

            console.log("🔹 Résultat de find() :", this.dataIdPeople);

            if (!this.dataIdPeople) {
              console.warn(`⚠️ Aucun élément trouvé avec la valeur '${storedValue}' dans data_option_people_name`);
            } else {
              console.log("✅ Élément trouvé :", this.dataIdPeople);
            }
          }
        }, 1000);
      }

      localStorage.removeItem('creating-operation-and-need-to-add-user');
      localStorage.removeItem('creating-operation-and-need-to-add-user-category');
      localStorage.removeItem('creating-operation-and-need-to-add-user-date');
      localStorage.removeItem('creating-operation-and-need-to-add-user-page-source');
    },
    save_changes () {
      if (moment(this.maxdateoperation).add(12, 'hours') >= moment(this.dataDate))
      {
        this.$vs.notify({
          color: 'danger',
          title: 'Wrong Date!',
          text: 'You cannot add a sale after an Inventory! (Inventory date : '+this.maxdateoperation+')'
        })
        return
      }
      let personId = null
      if (this.dataIdPeople) {
        if (this.dataIdPeople.value) personId = this.dataIdPeople.value
        else personId = this.dataIdPeople[0].value
      }
      const obj = {
        date: moment(this.dataDate).add(12, 'hours').format('YYYY-MM-DD hh:mm:ss+02'),
        operationcategory: this.dataOperationCategory,
        idperson: personId,
        idsalestatus: 1,
        isactive: true
      }
      {
        this.$store.dispatch('operationList/createOperation', obj)
        .then(response =>
          {
          this.$vs.notify({
            color: 'success',
            title: '',
            text: 'Operation Correctly Started!'
          })
          this.$router.push({path:'/sale-edit/' + this.$store.state.operationList.operation.id})
          }
        )        
        .catch(err => { 
        this.$vs.notify({
          color: 'alert',
          title: 'An Error Occured!',
          text: 'The operation was NOT added, please contact your dev'
        }) })
      }
    }
  },
  mounted () {
    this.isMounted = true
  },
  created() {
    this.getPeople()
    this.dataDate = moment().format("D MMM yyyy")
    this.getMaxInventoryDate()
  }
}
</script>

